import React, { useMemo, useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import SafeImage from "@/components/SafeImage";
import { GALLERY, GALLERY_FILTERS } from "@/data/content";

const Gallery = () => {
  const [filter, setFilter] = useState("all");

  const items = useMemo(() => {
    if (filter === "all") return GALLERY;
    return GALLERY.filter((g) => g.category === filter);
  }, [filter]);

  return (
    <>
      <SEO />
      <PageHero
        crumbs={[{ label: "Početna", to: "/" }, { label: "Galerija" }]}
        title="Galerija"
        lead="Primeri izvedenih kontejnera. Filtrirajte po kategoriji."
      />

      <section className="section" data-testid="gallery-page">
        <div className="container-rb">
          <div className="gallery-filters" role="tablist" aria-label="Filteri galerije">
            {GALLERY_FILTERS.map((f) => (
              <button
                key={f.key}
                role="tab"
                aria-selected={filter === f.key}
                className={`gallery-filter ${filter === f.key ? "active" : ""}`}
                onClick={() => setFilter(f.key)}
                data-testid={`gallery-filter-${f.key}`}
              >
                {f.label}
              </button>
            ))}
          </div>

          {items.length === 0 ? (
            <div style={{ padding: 40, textAlign: "center", color: "#6b7280" }} data-testid="gallery-empty">
              Nema rezultata za izabrani filter.
            </div>
          ) : (
            <div className="gallery-grid">
              {items.map((g, i) => (
                <div key={`${g.src}-${i}`} className="gallery-item" data-testid={`gallery-item-${i}`}>
                  <SafeImage src={g.src} alt={g.label} label={g.label} loading="lazy" />
                  <span className="gallery-item__label">{g.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <FinalCTA />
    </>
  );
};

export default Gallery;
